export const breakpoints = ['375px', '768px', '1280px', '1920px']
